/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.UploadBatchFileResponse | undefined,
  GetUploads: (params: vp.UploadBatchRequest) => void,
  reset: () => void,
  GetUploadsAsync: (params: vp.UploadBatchRequest) => Promise<vp.UploadBatchFileResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchUploadedFiles: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldGetUpload, setShouldGetUpload] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.UploadBatchRequest>({});
  const [response, setResponse] = useState<vp.UploadBatchFileResponse>();

  useEffect(() => {
    if (!shouldGetUpload) return () => {};

    const PostBulkCollection = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');

      const res = await api.fetchUploadedFiles(params, source);

      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldGetUpload) void PostBulkCollection();
    setShouldGetUpload(false);
    return () => {
      source.cancel();
    };
  }, [shouldGetUpload]);

  return [
    response,
    (_params: vp.UploadBatchRequest) => {
      setParams(_params);
      setShouldGetUpload(true);
    },
    () => {
      setResponse(undefined);
      setShouldGetUpload(false);
    },
    async (requestParams: vp.UploadBatchRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.fetchUploadedFiles(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchUploadedFiles);
